/*
 * @Author: 沉梦 chenmxgg@163.com <blog.achaci.cn>
 * @Date: 2022-10-19 19:31:44
 * @LastEditors: 沉梦 chenmxgg@163.com <blog.achaci.cn>
 * @LastEditTime: 2022-10-21 21:02:16
 * @FilePath: \v1.0.0.2\src\store\modules\user.js
 * @Description: 
 * 
 * Copyright (c) 2022 by 成都沉梦科技, All Rights Reserved. 
 */


import tool from "@/utils/tool";
import authConfig from "@/config/auth";
import {Dialog} from "vant";

// 辅助函数：处理请求路径
function socketHandlePath(path) {
    let arr = path.split('//');
    if (arr.length >= 2) {
        path = arr[1];
        let parts = path.split('/', 2);
        if (parts.length > 1) {
            path = path.substring(parts[0].length + 1);
        }
    }

    if (path.startsWith('/')) {
        path = path.substr(1);
    }

    return path;
}

// WebSocket 相关的 Vuex 模块
const socketModule = {
    namespaced: true,
    state: {
        // 更改为对象，以存储不同URL对应的WebSocket实例
        gateway_servers: {},
        gateway_server: null,
        // 链接模式 0 单线程 1 多线程
        gateway_type: 0,
        errorShow: false,
        baseType: null,
        ws: null,
        connectOk: false,
        isFirst: true,
        connectErrorIndex: 0,
        myInterval: null,
        waitSends: [],
        callbacks: {},
        sendBeforeFun: null, // 用于保存 sendBefore 函数
        callBeforeFun: null, // 用于保存 callBefore 函数
        sendBeforeFunAsync: true,
        callBeforeFunAsync: true,
        timeout: 30 * 1000,
    },
    mutations: {
        Init(state, {gateway_server, baseType}) {
            if (!gateway_server || gateway_server == 'null') {
                return;
            }
            console.log('gateway_server', gateway_server);
            if (!gateway_server.includes('ws')) {
                gateway_server = gateway_server.replace('https', 'wss').replace('http', 'ws');
            }

            state.gateway_server = gateway_server
            if (state.gateway_type == 1) {
                if (!(gateway_server in state.gateway_servers)) {
                    state.gateway_servers[gateway_server] = {
                        ws: null,
                        connectOk: false,
                        isFirst: true,
                        connectErrorIndex: 0,
                        myInterval: null,
                        waitSends: [],
                        callbacks: {},
                        sendBeforeFun: null,
                        callBeforeFun: null,
                        sendBeforeFunAsync: true,
                        callBeforeFunAsync: true,
                        timeout: 30 * 1000,
                        baseType: baseType,
                    }
                }
            }
        },
        setConnectStatus(state, {url, status}) {
            if (url in state.gateway_servers) {
                let serverState = state.gateway_servers[url];
                serverState.connectOk = status;
                serverState.isFirst = !status;
            }
        },
        resetConnectErrorIndex(state, url) {
            if (url in state.gateway_servers) {
                state.gateway_servers[url].connectErrorIndex = 0;
            }
        },
        incrementConnectErrorIndex(state, url) {
            if (url in state.gateway_servers) {
                state.gateway_servers[url].connectErrorIndex += 1;
            }
        },
        clearMyInterval(state, url) {
            if (url in state.gateway_servers && state.gateway_servers[url].myInterval) {
                clearInterval(state.gateway_servers[url].myInterval);
                state.gateway_servers[url].myInterval = null;
            }
        },
        setTimeout(state, {url, timeout}) {
            if (url in state.gateway_servers) {
                state.gateway_servers[url].timeout = timeout;
            }
        },
        addWaitSend(state, {url, payload}) {
            if (url in state.gateway_servers) {
                state.gateway_servers[url].waitSends.push(payload);
            }
        },
        clearWaitSends(state, url) {
            if (url in state.gateway_servers) {
                state.gateway_servers[url].waitSends = [];
            }
        },
        createCallback(state, {url, id, call}) {
            if (url in state.gateway_servers) {
                const serverState = state.gateway_servers[url];
                const setTimeoutId = setTimeout(() => {
                    if (serverState.callbacks[id]) {
                        serverState.callbacks[id].call(this.timeoutRes);
                        delete serverState.callbacks[id];
                    }
                }, serverState.timeout);

                serverState.callbacks[id] = {
                    call: call,
                    setTimeoutId: setTimeoutId
                };
            }
        },
        setWs(state, {ws, url}) {
            if (url in state.gateway_servers) {
                state.gateway_servers[url].ws = ws;
            } else {
                state.gateway_servers[url] = {
                    ws: ws,
                    connectOk: false,
                    isFirst: true,
                    connectErrorIndex: 0,
                    myInterval: null,
                    waitSends: [],
                    callbacks: {},
                    sendBeforeFun: (params) => {
                        return new Promise((resolve) => {
                            // console.log('params', params);
                            const {data, url} = params;
                            let path = socketHandlePath(url);
                            data.client_ip = ('webInfo' in window) && ('client_ip' in window.webInfo) ? window.webInfo.client_ip : tool.data.get('clientip');
                            data.user_token = tool.data.get('token');
                            data.user_agent = navigator.userAgent || '';
                            data.token = tool.data.get('token');
                            data.host = 'webInfo' in window ? ('host' in window.webInfo ? window.webInfo.host : 'iot.cmyo.cn') : 'iot.cmyo.cn';
                            resolve([data, {type: 'index', path}]);
                        })

                    },
                    callBeforeFun: (response) => {
                        return new Promise((resolve, reject) => {
                            if (response.code != 200) {
                                if (response.code == authConfig.nologin.code) {
                                    // Toast.fail(authConfig.nologin.message);
                                    authConfig.nologin.action()
                                    return reject(response)
                                } else if (response.code == authConfig.noauth.code) {
                                    // Toast.fail(authConfig.noauth.message);
                                    authConfig.noauth.action()
                                    return reject(response)
                                } else {
                                    return resolve(Object.assign(response, {
                                        'data': typeof response.data == 'undefined' ? [] : response.data
                                    }))
                                }
                            } else {
                                return resolve(response);
                            }
                        })
                    },
                    sendBeforeFunAsync: true,
                    callBeforeFunAsync: true,
                    timeout: 30 * 1000,
                };
            }
        },

        setHeartbeatInterval(state, {url, Interval}) {
            if (url in state.gateway_servers) {
                state.gateway_servers[url].myInterval = Interval;
            }
        },
        setErrorShow(state, value) {
            state.errorShow = value
        },
        setConnectStatusOnce(state, status) {
            state.connectOk = status;
            state.isFirst = !status;
        },
        setisFirstOnce(state, status) {
            state.isFirst = !status;
        },
        resetConnectErrorIndexOnce(state) {
            state.connectErrorIndex = 0;
        },
        incrementConnectErrorIndexOnce(state) {
            state.connectErrorIndex += 1;
        },
        clearWaitSendsOnce(state) {
            state.waitSends = [];
        },
        clearMyIntervalOnce(state) {
            if (state.myInterval) {
                clearInterval(state.myInterval);
            }
            state.myInterval = null;
        },
        addWaitSendOnce(state, {payload}) {
            state.waitSends.push(payload);
            // console.log('waitSends=> ', state.waitSends);
        },
        setTimeoutOnce(state, {url, timeout}) {
            state.timeout = timeout;
        },
        setWsOnce(state, {ws}) {

            // state.waitSends = []
            state.callbacks = {}
            state.myInterval = null
            state.sendBeforeFun = (params) => {
                // console.log('params', params);
                const {data, url} = params;
                let path = socketHandlePath(url);
                data.client_ip = tool.data.get('clientip');
                data.user_token = tool.data.get('token');
                data.user_agent = navigator.userAgent || '';
                data.token = tool.data.get('token');
                data.host = 'webInfo' in window ? ('host' in window.webInfo ? window.webInfo.host : 'iot.cmyo.cn') : 'iot.cmyo.cn';
                return [data, {type: 'index', path}];
            };

            state.callBeforeFun = (response) => {
                if (response.code != 200) {
                    if (response.code == authConfig.nologin.code) {
                        // Toast.fail(authConfig.nologin.message);
                        authConfig.nologin.action()
                        return Promise.reject(response)
                    } else if (response.code == authConfig.noauth.code) {
                        // Toast.fail(authConfig.noauth.message);
                        authConfig.noauth.action()
                        return Promise.reject(response)
                    } else {
                        return Promise.resolve(Object.assign(response, {
                            'data': typeof response.data == 'undefined' ? [] : response.data
                        }))
                    }
                } else {
                    return response;
                }
            };
            state.sendBeforeFunAsync = true;
            state.callBeforeFunAsync = true;
            state.timeout = 30 * 1000;
            state.ws = ws;
        },
        setHeartbeatIntervalOnce(state, {Interval}) {
            state.myInterval = Interval;
        },
        setErrorShowOnce(state, value) {
            state.errorShow = value
        },
        createCallbackOnce(state, {id, call}) {
            const setTimeoutId = setTimeout(() => {
                if (state.callbacks[id]) {
                    state.callbacks[id].call(this.timeoutRes);
                    delete state.callbacks[id];
                }
            }, state.timeout);

            state.callbacks[id] = {
                call: call,
                setTimeoutId: setTimeoutId
            };
        },
    },
    actions: {
        async init({commit, dispatch}, {gateway_server, baseType}) {
            await commit('Init', {gateway_server, baseType});
            dispatch('connect', {gateway_server});
        },
        connect({state, commit, dispatch}, {url = null, success = null, fail = null}) {

            if (!state.gateway_server || state.gateway_server == 'null') {
                // console.log('WS退出');
                return;
            }

            if (state.gateway_type == 1) {
                if (url in state.gateway_servers && state.gateway_servers[url].ws) {
                    // console.log('WS退出2');
                    return;
                }

                const ws = new WebSocket(state.gateway_server);

                ws.onmessage = (e) => dispatch('handleMessage', {url, e});
                ws.onopen = () => {
                    console.info('WS链接: 异步会话服务链接成功, 多线程');
                    commit('setConnectStatus', {url, status: true});
                    commit('resetConnectErrorIndex', url);

                    if (!state.gateway_servers[url].myInterval) {
                        dispatch('startHeartbeat', url);
                    }

                    state.gateway_servers[url].waitSends.forEach((item) => dispatch('send', item));
                    commit('clearWaitSends', url);

                    if (success) {
                        success(state);
                    }
                };

                ws.onclose = () => {
                    commit('setConnectStatus', {url, status: false});
                    commit('clearMyInterval', url);

                    setTimeout(() => {
                        if (state.gateway_servers[url].connectErrorIndex < 100) {
                            console.log('WS链接: 链接已断开, 稍后重试');
                            dispatch('connect', {url});
                        } else {
                            console.log('WS链接: 链接已断开, 已重试100次, 请检查服务器');
                            // Handle long connection timeout
                        }
                    }, 5000);
                };

                ws.onerror = (e) => {
                    commit('setConnectStatus', {url, status: false});
                    console.error("出现错误", e);
                    if (fail) {
                        fail(state);
                    }
                };
                commit('setWs', {ws, url});
            } else {
                if (!state.isFirst) {
                    console.info('WS链接: 异步会话服务链接正在链接中');
                    return false;
                }

                if (state.ws && 'object' === typeof state.ws && state.ws.readyState === WebSocket.OPEN) {
                    console.info('WS链接: 异步会话服务链接已经成功');
                    if (success) {
                        success(state);
                    }
                    return;
                }

                const ws = new WebSocket(state.gateway_server);

                ws.onmessage = (e) => dispatch('handleMessage', {url, e});
                ws.onopen = () => {
                    // if (isFirst) {
                    //     console.info('WS链接: 异步会话服务链接成功, 首次');
                    // }
                    // else {

                    // }
                    console.info('WS链接: 异步会话服务链接成功, 单线程');
                    commit('setConnectStatusOnce', true);
                    commit('resetConnectErrorIndexOnce');
                    // commit('setWsOnce', {ws});
                    setTimeout(() => {
                        if (!state.myInterval) {
                            dispatch('startHeartbeatOnce');
                        }

                        if (Array.isArray(state.waitSends)) {
                            // console.log('state.waitSends', state.waitSends);
                            state.waitSends.forEach((item) => dispatch('send', item));
                        }
                        // commit('clearWaitSendsOnce');
                        if (success) {
                            success(state);
                        }
                    }, 0)
                };

                ws.onclose = () => {
                    commit('setConnectStatusOnce', false);
                    commit('clearMyIntervalOnce');
                    setTimeout(() => {
                        if (state.connectErrorIndex < 100) {
                            console.log('WS链接: 链接已断开, 稍后重试');
                            dispatch('connect', {url});
                        } else {
                            console.log('WS链接: 链接已断开, 已重试100次, 请检查服务器');
                            // Handle long connection timeout
                        }
                    }, 5000);
                };

                ws.onerror = (e) => {
                    commit('clearMyIntervalOnce');
                    commit('setConnectStatusOnce', false);
                    console.error("出现错误", e);
                    // commit('setWsOnce', {ws});
                    if (fail) {
                        fail(state);
                    }
                    setTimeout(() => {
                        if (state.connectErrorIndex < 100) {
                            console.log('WS链接: 链接已断开, 稍后重试');
                            dispatch('connect', {url});
                        } else {
                            console.log('WS链接: 链接已断开, 已重试100次, 请检查服务器');
                            // Handle long connection timeout
                        }
                    }, 5000);
                };

                window.document.addEventListener('visibilitychange', () => {
                    if (document.hidden) {
                        this.connectErrorIndex = 0;
                        // 页面不可见时的操作，比如暂停游戏或视频
                    } else {
                        console.log('异步会话: 页面已显示');
                        if (this.connectOk === false) {
                            console.log('异步会话: 已断开, 开始重连');
                            dispatch('connect', {url});
                        }
                        // 页面可见时的操作，比如恢复游戏或视频
                    }
                });
                window.addEventListener('pagehide', (event) => {
                    if (event.persisted || (window.performance && window.performance.navigation.type == 2)) {
                        this.connectErrorIndex = 0;
                        console.log('异步会话, 页面从缓存中恢复');
                        if (this.connectOk === false) {
                            console.log('异步会话: 已断开, 开始重连');
                            dispatch('connect', {url});
                        }
                    }
                });
                commit('setWsOnce', {ws});

            }
        },
        startHeartbeat({commit, dispatch}, url) {
            dispatch('keepOnLine', url);
            const Interval = setInterval(() => dispatch('keepOnLine', url), 80 * 1000);
            commit('setHeartbeatInterval', {url, Interval});
        },
        keepOnLine({state, dispatch}, url) {
            if (url in state.gateway_servers && state.gateway_servers[url].connectOk) {
                state.gateway_servers[url].ws.send(JSON.stringify({type: 'ping'}));
            } else if (url in state.gateway_servers && state.gateway_servers[url].isFirst && state.gateway_servers[url].connectErrorIndex === 0) {
                console.log('自动断线重连');
                dispatch('connect', {url});
            }
        },
        startHeartbeatOnce({commit, dispatch}) {
            commit('clearMyIntervalOnce');
            dispatch('keepOnLineOnce');
            const Interval = setInterval(() => dispatch('keepOnLineOnce'), 80 * 1000);
            commit('setHeartbeatIntervalOnce', {Interval});
        },
        keepOnLineOnce({state, dispatch}) {
            if (state.connectOk && state.ws && state.ws.readyState === WebSocket.OPEN) {
                state.ws.send(JSON.stringify({type: 'ping'}));
            } else if (state.isFirst && state.connectErrorIndex === 0) {
                console.log('自动断线重连');
                dispatch('connect', {url: ''});
            }
        },
        checkApi({state}, url) {
            if (url in state.gateway_servers) {
                state.gateway_servers[url].ws.send(JSON.stringify({type: state.gateway_servers[url].baseType, wsaction: 'check'}));
            }
        },
        async handleMessage({state, commit, dispatch}, {url, e}) {
            try {
                const data = JSON.parse(e.data);
                if (data && (state.gateway_type == 0 || url in state.gateway_servers)) {
                    switch (data.type) {
                        case 'ping':
                            break;
                        case 'check':
                            // console.log('Socket check received');
                            break;
                        case 'login':
                            // console.log('Socket login received');
                            break;
                        case 'callback':
                            // console.log('Socket callback received');
                            break;
                        case 'call':
                            if (state.gateway_type == 1) {
                                if (data.id && state.gateway_servers[url].callbacks[data.id]) {
                                    let processedData = state.gateway_servers[url].callBeforeFunAsync
                                        ? await state.gateway_servers[url].callBeforeFun(data)
                                        : state.gateway_servers[url].callBeforeFun(data);

                                    state.gateway_servers[url].callbacks[data.id].call(processedData);
                                    clearTimeout(state.gateway_servers[url].callbacks[data.id].setTimeoutId);
                                    delete state.gateway_servers[url].callbacks[data.id];
                                }
                            } else {
                                if (data.id && state.callbacks[data.id]) {
                                    let processedData = state.callBeforeFunAsync
                                        ? await state.callBeforeFun(data)
                                        : state.callBeforeFun(data);

                                    state.callbacks[data.id].call(processedData);
                                    clearTimeout(state.callbacks[data.id].setTimeoutId);
                                    delete state.callbacks[data.id];
                                }
                            }

                            break;
                        default:
                            console.warn('Unknown message type:', data.type);
                    }
                } else {
                    console.error("WS错误消息: WS回调解析失败", data);
                }
            } catch (error) {
                console.error("WS错误消息:", e.data, error);
            }
        },
        async send({state, commit, dispatch}, payload) {
            const {
                method,
                url,
                data,
                call
            } = payload; // 假设 payload 中包含了 gateway_server 和 url

            if (!url) {
                // console.log('WS退出1');
                return;
            }

            // console.log('state.gateway_type', state.gateway_type);
            if (state.gateway_type == 0) {
                // 单一链接模式 节省链接开销
                if (!state.connectOk) {
                    await commit('addWaitSendOnce', {payload});
                    // if (state.isFirst) {
                    //     await commit('setisFirstOnce', false);
                    //     console.log('// 单一链接模式 节省链接开销');
                    //     dispatch('connect', {url});
                    // }
                }
                else {
                    let ws = state.ws;
                    if ('object' === typeof ws && ws.readyState === WebSocket.OPEN) {
                        let [resData, resParams] = state.sendBeforeFunAsync
                            ? await state.sendBeforeFun({
                                method,
                                url,
                                data,
                                call
                            })
                            : state.sendBeforeFun({
                                method,
                                url,
                                data,
                                call
                            });

                        const post = resParams
                            ? {...{id: tool.crypto.MD5(JSON.stringify([...payload]) + Math.random()), data: resData}, ...resParams}
                            : {id: tool.crypto.MD5(JSON.stringify([...payload]) + Math.random()), data: resData};

                        await dispatch('createCallbackOnce', {id: post.id, call: call});
                        ws.send(JSON.stringify(post));
                    } else {
                        commit('addWaitSendOnce', {payload});
                        dispatch('connect', {url});
                        console.log('链接已经断开, 等待重新链接');
                    }
                }
                return;
            }

            if (!(url in state.gateway_servers) || !state.gateway_servers[url].ws) {
                dispatch('connect', {
                    url,
                    fail: (state) => {
                        console.log('WS退出2');
                        if (!state.errorShow) {
                            dispatch('setErrorShow', true);
                            Dialog.confirm({
                                title: '错误提示',
                                message: '服务器链接请求超时, 请联系网站管理员处理~',
                                confirmButtonText: '好的'
                            }).then(() => {

                            }).catch(() => {

                            });
                            console.error("WS错误消息: WS链接失败", state);
                        }
                    },
                    success: async (state) => {
                        if (url in state.gateway_servers) {
                            let ws = state.gateway_servers[url].ws;
                            if (ws.readyState === WebSocket.OPEN) {
                                let [resData, resParams] = state.gateway_servers[url].sendBeforeFunAsync
                                    ? await state.gateway_servers[url].sendBeforeFun({
                                        method,
                                        url,
                                        data,
                                        call
                                    })
                                    : state.gateway_servers[url].sendBeforeFun({
                                        method,
                                        url,
                                        data,
                                        call
                                    });

                                const post = resParams
                                    ? {...{id: tool.crypto.MD5(JSON.stringify([...payload]) + Math.random()), data: resData}, ...resParams}
                                    : {id: tool.crypto.MD5(JSON.stringify([...payload]) + Math.random()), data: resData};

                                await dispatch('createCallback', {url, id: post.id, call: call});
                                ws.send(JSON.stringify(post));
                            } else {
                                commit('addWaitSend', {url, payload});
                                if (!state.gateway_servers[url].isFirst && state.gateway_servers[url].connectErrorIndex < 3) {
                                    console.log('自动断线重连');
                                    dispatch('connect', {gateway_server});
                                }
                            }
                        }
                    }
                });
            } else {
                let ws = state.gateway_servers[url].ws;
                if (ws.readyState === WebSocket.OPEN) {
                    let [resData, resParams] = state.gateway_servers[url].sendBeforeFunAsync
                        ? await state.gateway_servers[url].sendBeforeFun({
                            method,
                            url,
                            data,
                            call
                        })
                        : state.gateway_servers[url].sendBeforeFun({
                            method,
                            url,
                            data,
                            call
                        });

                    const post = resParams
                        ? {...{id: tool.crypto.MD5(JSON.stringify([...payload]) + Math.random()), data: resData}, ...resParams}
                        : {id: tool.crypto.MD5(JSON.stringify([...payload]) + Math.random()), data: resData};

                    await dispatch('createCallback', {url, id: post.id, call: call});
                    ws.send(JSON.stringify(post));
                } else {
                    commit('addWaitSend', {url, payload});
                    if (!state.gateway_servers[url].isFirst && state.gateway_servers[url].connectErrorIndex < 3) {
                        console.log('自动断线重连');
                        dispatch('connect', {gateway_server});
                    }
                }
            }
        },
        createCallbackOnce({commit}, {id, call}) {
            if (Object.prototype.toString.call(call) === '[object Function]') {
                commit('createCallbackOnce', {id, call});
            }
        },
        createCallback({state, commit}, {url, id, call}) {
            if (Object.prototype.toString.call(call) === '[object Function]' && url in state.gateway_servers) {
                commit('createCallback', {url, id, call});
            }
        },
    },
};

export default socketModule;


// WEBPACK FOOTER //
// ./src/store/modules/socket.js